module.exports = __webpack_public_path__ + "static/media/lock.c719c6b1.svg";